import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import WhySwitch from './components/WhySwitch/WhySwitch';
import TopFeatures from './components/TopFeatures/TopFeatures';
import Pricing from './components/Pricing/Pricing';
// import Automation from './components/Automation/Automation';
import GlobalReach from './components/GlobalReach/GlobalReach';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
// import AddSubaccount from './pages/AddSubaccount';
import InvoiceList from './pages/InvoiceList';
import SubscribedLocations from './pages/SubscribedLocations';
import Profile from './pages/Profile';
import AuthSuccess from './pages/AuthSuccess';
import QRScan from './pages/QRScan';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import Success from './pages/Success';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import FAQ from './pages/FAQ';
import OTPVerification from './pages/OTPVerification';
import { APP_ROUTES } from './config/api.config';
import styled from 'styled-components';
import { setupTokenExpirationCheck, checkAuthAndLogout } from './utils/auth';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = checkAuthAndLogout();
  console.log('PrivateRoute - isAuthenticated:', isAuthenticated);

  if (!isAuthenticated) {
    console.log('Redirecting to login...');
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

const QRScanRoute: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const hasEmbedToken = Boolean(params.get('token') && params.get('locationId'));

  if (hasEmbedToken) {
    return <QRScan embedMode />;
  }

  return (
    <PrivateRoute>
      <QRScan />
    </PrivateRoute>
  );
};

const LandingPageLayout = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: var(--light-color);
`;

const MainContent = styled.main`
  flex: 1;
`;

const App: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: 'mobile'
    });

    setupTokenExpirationCheck();
  }, []);

  return (
    <>
      <GlobalStyles />
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />
        <Routes>
          {/* Public routes */}
          <Route path={APP_ROUTES.LOGIN} element={<Login />} />
          <Route path={APP_ROUTES.REGISTER} element={<Register />} />
          <Route path={APP_ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={APP_ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={APP_ROUTES.AUTH_SUCCESS} element={<AuthSuccess />} />
          <Route
            path={APP_ROUTES.QR_SCAN}
            element={<QRScanRoute />}
          />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/success" element={<Success />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/verify-otp" element={<OTPVerification />} />

          {/* Protected routes */}
          <Route
            path={APP_ROUTES.DASHBOARD}
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          {/* <Route
            path={APP_ROUTES.ADD_SUBACCOUNT}
            element={
              <PrivateRoute>
                <AddSubaccount />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/invoice-list"
            element={
              <PrivateRoute>
                <InvoiceList />
              </PrivateRoute>
            }
          />
          <Route
            path={APP_ROUTES.FAQ}
            element={
              <PrivateRoute>
                <FAQ />
              </PrivateRoute>
            }
          />
          <Route
            path={APP_ROUTES.SUBSCRIBED_LOCATIONS}
            element={
              <PrivateRoute>
                <SubscribedLocations />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/qr-scan"
            element={
              <PrivateRoute>
                <QRScan />
              </PrivateRoute>
            }
          /> */}

          {/* Landing page route */}
          <Route
            path="/"
            element={
              <LandingPageLayout>
                <Header />
                <MainContent>
                  <Hero />
                  <WhySwitch />
                  <TopFeatures />
                  <Pricing />
                  {/* <Automation /> */}
                  <GlobalReach />
                  <Contact />
                </MainContent>
                <Footer />
              </LandingPageLayout>
            }
          />

          Catch all route
          <Route
            path="*"
            element={
              localStorage.getItem('token') ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
      </Router>
    </>
  );
};

export default App;
